<template>
  <div>
    <app-header />
    <div class="swiper-box ctimaging" @mousewheel="rollScroll" style="float: left;width: 100%;height: 100vh;">
      <el-carousel sty height="100vh" trigger="click" :loop="false" direction="vertical" :autoplay="false" ref="carousel">
        <el-carousel-item key="1">
          <div style="float: left;width: 100%;position: relative;">
            <!-- <img src="@/assets/images/cardiobrain/diyim.png" alt="" style="width: 100%;height: 100vh;position: absolute;z-index: 0;left: 0;top: 0;"> -->
            <div style="width: 100%;height: 100vh;position: absolute;z-index: 0;left: 0;top: 0;background: linear-gradient(129deg, #289EA5 0%, #14C89B 100%);"></div>
            <div style="width: 1380px;height: 100vh;position: relative;margin: 0 auto;z-index: 1;">
              <div style="width: 448px;height: 148px;font-size: 56px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #FFFFFF;line-height: 74px;float: left;margin-top: 260px;">CT影像文本智能<br>解读系统</div>
              <!--   980 720= 920 676px -->
              <img src="@/assets/images/ctimaging/ctjiedudiyiimg.png" class="donghua" alt="" style="width:920px;height:676px;float: right;margin-top: 148px;">
              <div style="width: 288px;height: 72px;font-size: 24px;font-family: MicrosoftYaHei;color: #FFFFFF;line-height: 36px;float: left;margin-top: 40px;margin-right: 100px;">透过影像文本解读身体真相<br></div>
              <div style="width: 200px;height: 50px;background: #FFFFFF;box-shadow: 0px 2px 4px 0px #1db49f;border-radius: 30px;font-size: 16px;font-family: MicrosoftYaHei;color: #1DB49F;line-height: 50px;text-align: center;float: left;margin-top: 100px;cursor: pointer;" @click="cl = true">点击获取报价>></div>
            </div>
          </div>
        </el-carousel-item>



        <el-carousel-item key="2">
          <div style="float: left;width: 100%;position: relative;">
            <img src="@/assets/images/cardiobrain/diyim1.png" alt="" style="width: 100%;height: 100vh;position: absolute;z-index: 0;left: 0;top: 0;">
            <div style="width: 1200px;height: 100vh;position: relative;margin: 0 auto;z-index: 1;">
              <div style="width: 100%;float: left;margin-left: 0;margin-top: 10%;">
                <div style="width: 100%;float: left;font-size: 40px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #000000;text-align: center;overflow: hidden;">CT影像文本智能解读系统</div>
                <div style="float: left;margin-top: 30px;width: 100%;">
                  <div style="width: 100px;height: 10px;background: linear-gradient(127deg, #289EA5 0%, #14C89B 100%);margin: 0 auto;"></div>
                </div>
                 <div style="float: left;margin-top: 30px;width: 100%;">
                    <div style="width: 1000px;height: 70px;font-size: 16px;font-family: MicrosoftYaHei;color: #000000;line-height: 24px;text-align: center;margin:0 auto;">
                    吾征凭借大数据和人工能智能算法能力等优势，通过提取CT影像检查可见等文本信息，进行分词处理并进行清洗，完成异常特征的精准划分和统计，利用吾征AI底层疾病与症状词性注意力模型建立关联性和融合语义认知计算，从而得出影像文本的智能解读结论、疾病风险及个性化健康建议，辅助医生诊断和校正，为用户和医生（机构）提供双向服务。
                  </div>
                </div>
              </div>
              <img src="@/assets/images/ctimaging/ctjiedudiyiimg1.png" alt="" class="donghua" style="width: 1252px;height: 548px;float: left;margin-top: 4%;margin-left: 0;">
            </div>
          </div>
        </el-carousel-item>



        <el-carousel-item key="3">
          <div style="float: left;width: 100%;position: relative;">
            <div style="width: 100%;height: 100vh;position: absolute;z-index: 0;left: 0;top: 0;background: #fff;"></div>
            <div style="width: 1200px;height: 100vh;position: relative;margin: 0 auto;z-index: 1;">
                <div style="width: 100%;float: left;font-size: 40px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #000000;text-align: center;overflow: hidden;margin-top: 10%;margin-bottom:30px;">技术优势</div>
                <div style="float: left;width: 100%;margin-bottom:120px;">
                      <div style="width: 100px;height: 10px;background: linear-gradient(127deg, #289EA5 0%, #14C89B 100%);margin: 0 auto;"></div>
                </div>
                <div style="width: 100%;float: left;position: relative;">
                    <div style="width: 100%;position: absolute;float: left;">
                      <div style="width: 720px;height: 450px;border-radius: 20px;opacity: 0.3;border-width: 5px;border-style: dashed;border-color: initial;border-radius: 20px;border-color: rgb(20, 200, 155);position: relative;left: 240px;top: 60px;">
                      </div>
                    </div>

                    <div class="donghua" style="width: 720px;height: 450px;background: linear-gradient(129deg, #289EA5 0%, #14C89B 100%);border-radius: 20px;padding: 50px;position: absolute;top:  0px;left:0px;">
                      <div style="width: 500px;height: 26px;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #FFFFFF;line-height: 26px;margin-top: 10px;position: absolute;">
                        自有专利支撑，由吾征独家发明的影像文本智能分析方法
                      </div>
                      <div style="width: 380px;height: 268px;font-size: 14px;font-family: MicrosoftYaHei;color: #FFFFFF;line-height: 22px;margin-top: 60px;position: absolute;">
                          一种基于NEZHA与注意力机制融合的BI-LSTM医学影像报告多标签多分类方法<br/>
                          <div style="width: 100%;height: 20px;"></div>
                          一种基于LSTM-TextCNN融合模型的医学影像报告肺部特征检测方法<br/>
                          <div style="width: 100%;height: 20px;"></div>
                          一种结合AdaBERT的改进TextCNN医学影像报告肝脏特征检测方法<br/>
                          <div style="width: 100%;height: 20px;"></div>
                          一种基于嵌入式注意力机制的医学影像报告肾脏特征检测方法<br/>
                          <div style="width: 100%;height: 20px;"></div>
                          ……
                      </div>
                    </div>
                    <img src="@/assets/images/ctimaging/ctjiedudiyiimg2.png" class="donghua" alt="" style="width: 720px;height: 450px;float: left; margin-left: 0;position: absolute;top: 120px;left: 480px;">
                </div>
            </div>
          </div>
        </el-carousel-item>



        <el-carousel-item key="4">
          <div style="width: 100%;height: 100vh;position: absolute;z-index: 0;left: 0;top: 0;background: #F2FBFA;">
    
             <div style="width: 100%;float: left;font-size: 40px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #000000;text-align: center;overflow: hidden;margin-top: 10%;margin-bottom:30px;">技术优势</div>
              <div style="float: left;width: 100%;margin-bottom:4%;">
                 <div style="width: 100px;height: 10px;background: linear-gradient(127deg, #289EA5 0%, #14C89B 100%);margin: 0 auto;"></div>
              </div>

              <div style="float: left;width: 100%;padding-bottom: 4%;">
                    <div style="width: 580px;height: 52px;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #000000;line-height: 26px;text-align: center;margin:0 auto;">
                    历时5年，8万+CT影像文本训练人体生物特征多模态融合认知计算模型，像医生一样进行语言理解
                  </div>
             </div>
             <div style="width: 100%;float: left;">
              <div style="width: 1200px;position: relative;margin: 0 auto;">

                 <div style="width: 50%;position: absolute;left: 0;top: 0;" class="donghua">
                  <img src="@/assets/images/ctimaging/ctyoushileft.png"   style="width: 560px;height: 340px;position: absolute;z-index: 0;left: 0;top: 0">
                  <div style="width: 220px;height: 132px;font-size: 14px;font-family: MicrosoftYaHei;color: #000000;line-height: 22px;position: absolute;top: 84px;left: 310px;z-index: 1;">
                    通过全球8万多CT影像文本数据作为样本量，以医学影像报告异常检测数据为基础，获取了CT影像描述及描述中存在的异常区域与异常类型。对医疗AI预测潜在疾病具有参考价值和重要指导意义。
                  </div>
                </div>

                <div style="width: 50%;position: absolute;left: 50%;" class="donghua">
                   <img src="@/assets/images/ctimaging/ctyoushiright.png" alt="" style="width: 560px;height: 340px;position: absolute;z-index: 0;left: 0;top: 0">
                   <div style="width: 220px;height: 132px;font-size: 14px;font-family: MicrosoftYaHei;color: #000000;line-height: 22px;position: absolute;top: 84px;left: 310px;z-index: 1;">
                   通过5年来实现超过2000种疾病的风险评估和认知智能语义算法模型，开创国际国内健康认知智能的场景化应用先河，让系统像医生一样思考和理解。
                  </div>
                </div>
              </div>
             </div>
          </div>
        </el-carousel-item>



        <el-carousel-item key="5">
          <div style="float: left;width: 100%;position: relative;">
          <div style="float: left;width: 100%;position: relative;">
            <div  style="width: 100%;height: 100vh;position: absolute;z-index: 0;left: 0;top: 0;background: #fff;"></div>
            <div style="width: 1200px;height: 100vh;position: relative;margin: 0 auto;z-index: 1;">
                <div style="width: 100%;float: left;font-size: 40px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #000000;text-align: center;overflow: hidden;margin-top: 10%;margin-bottom:30px;">技术优势</div>
                <div style="float: left;width: 100%;margin-bottom:2%;">
                    <div style="width: 100px;height: 10px;background: linear-gradient(127deg, #289EA5 0%, #14C89B 100%);margin: 0 auto;"></div>
                </div>
            
                <div style="width: 100%;float: left;position: relative;" class="donghua">
                    <div style="width: 884px;height: 420px;background: linear-gradient(129deg, #289EA5 0%, #14C89B 100%);border-radius: 20px;padding: 50px;position: absolute;top: 140px;left:0px;z-index: 0;">
                      <div style="width: 500px;height: 26px;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #FFFFFF;line-height: 26px;top: 120px;left: 100px; position: absolute;">
                       提供18个部位的100+种疾病风险分析
                      </div>

                      <div style="width: 360px;height: 112px;font-size: 14px;font-family: MicrosoftYaHei;color: #FFFFFF;line-height: 22px;position: absolute;top: 180px;left: 100px;">
                          可对影像文本报告进行自动化解读，涉及人体18个主要部位、近万种特征以及百余种常见病。帮助用户及时发现异常，并对健康风险等级进行5级分层，并提供相应的专家建议、个性化健康管理方式，对高风险及确诊疾病提供专业的干预措施以及建议。
                          <div style="width: 100%;height: 20px;"></div>
                      </div>
                    </div>

                    <img src="@/assets/images/ctimaging/ctjieduimg5.png"  style="width: 700px;height: 700px;float: left; margin-left: 0;position: absolute;top:  0px;left: 480px;z-index: 1;">
                </div>
            </div>
          </div>
          </div>
        </el-carousel-item>



        <el-carousel-item key="6">
          <div style="float: left;width: 100%;position: relative;">
            <img  src="@/assets/images/cardiobrain/diyim1.png" alt="" style="width: 100%;height: 100vh;position: absolute;z-index: 0;left: 0;top: 0;">
            <div  style="width: 100%;height: 100vh;position: absolute;z-index: 0;left: 0;top: 0;background: linear-gradient(129deg, #289EA5 0%, #14C89B 100%);"></div>
            <div style="width: 1200px;height: 100vh;position: relative;margin: 0 auto;z-index: 1;">
              <div style="width: 100%;float: left;margin-left: 0;margin-top: 10%;padding-bottom: 5%">
                <div style="width: 100%;float: left;font-size: 40px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #FFFFFF;;text-align: center;overflow: hidden;">我们的服务</div>
                <div style="float: left;margin-top: 30px;width: 100%;">
                  <div style="width: 100px;height: 10px;background: #FFFFFF;margin: 0 auto;"></div>
                </div>
                 <div style="float: left;margin-top: 30px;width: 100%;">
                    <div style="width: 1000px;height: 70px;font-size: 16px;font-family: MicrosoftYaHei;color: #FFFFFF;line-height: 24px;text-align: center;margin:0 auto;">将影像报告上传或同步至吾征AI系统，快速创建个人健康数据管理账户后，吾征AI通过人体医学生物特征多模态认知计算，利用深度学习在自然语言处理中的特有优势进行报告结论分类，得出影像报告解析结果，以及可能引发的疾病种类，并提出诊疗建议
                  </div>
                </div>
              </div>


              <div style="width: 100%;float: left;margin-left: 0;">
                  <img src="@/assets/images/ctimaging/ctjieduimg6.png" class="donghua" alt="" style="width:620px;height: 450px;float: left;margin-left: 0;">
                  <div style="background: none;float: left;padding-left: 100px;">
                        <div style="width: 100%;padding-bottom: 60px;overflow: hidden;" :class="liclick==1?'donghua1 ctk6classact':'ctk6class'" @click="liclick=1">
                          <div class="left" style="margin-right: 30px;">
                              <div class="ziti" style="font-size: 24px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;width: 50px;height: 50px;text-align: center;line-height: 50px;border-radius: 50%">1</div>
                          </div>
                          <div class="right">
                            <div class="rightli" style="width: 100%;">
                              <div style="width: 160px;height: 26px;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #FFFFFF;line-height: 26px;">上传影像报告内容</div>
                              <div style="width: 400px;height: 66px;font-size: 14px;font-family: MicrosoftYaHei;color: #FFFFFF;line-height: 22px;">
                                在获得影像报告后，上传影像报告文字内容。机构及企业合作可直接对接系统实现数据同步；用户应用可通过文字录入、拍照等形式实现上传。
                              </div>
                            </div>
                          </div>
                        </div>


                         <div style="width: 100%;overflow: hidden;padding-bottom: 60px;" :class="liclick==2?'donghua1 ctk6classact':'ctk6class'" @click="liclick=2">
                          <div class="left" style="margin-right: 30px;">
                              <div class="ziti" style="font-size: 24px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #09BF88;width: 50px;height: 50px;text-align: center;line-height: 50px;border-radius: 50%">2</div>
                          </div>
                          <div class="right">
                            <div class="rightli" style="width: 100%;">
                              <div style="width: 160px;height: 26px;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #FFFFFF;line-height: 26px;">个性化健康方案</div>
                              <div style="width: 400px;height: 66px;font-size: 14px;font-family: MicrosoftYaHei;color: #FFFFFF;line-height: 22px;">
                                通过吾征AI大脑多模态认知分析，提取特征与报告异常区域、并建立异常类型之间的的联系，从而得出影像报告的结论以及疾病风险分析。
                              </div>
                            </div>
                          </div>
                        </div>

                         <div style="width: 100%;overflow: hidden;" :class="liclick==3?'donghua1 ctk6classact':'ctk6class'" @click="liclick=3">
                          <div class="left" style="margin-right: 30px;">
                              <div class="ziti" style="font-size: 24px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #09BF88;width: 50px;height: 50px;text-align: center;line-height: 50px;border-radius: 50%">3</div>
                          </div>
                          <div class="right">
                            <div class="rightli" style="width: 100%;">
                              <div style="width: 160px;height: 26px;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #FFFFFF;line-height: 26px;">个性化健康方案</div>
                              <div style="width: 400px;height: 66px;font-size: 14px;font-family: MicrosoftYaHei;color: #FFFFFF;line-height: 22px;">
                                根据每位用户的报告，给出个性化的饮食、运动以及专属保险方案等建议。
                              </div>
                            </div>
                          </div>
                        </div>


                  </div>
              </div>

            </div>
            
              
          </div>
            
        
        </el-carousel-item>
         <el-carousel-item key="7">
           <div style="float: left;width: 100%;position: relative;">
            <div style="width: 100%;height: 100vh;position: absolute;z-index: 0;left: 0;top: 0;background: #F2FBFA;;"></div>
            <div style="width: 1200px;height: 100vh;position: relative;margin: 0 auto;z-index: 1;">
            <div style="width: 100%;float: left;font-size: 40px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #000000;text-align: center;overflow: hidden;margin-top: 10%;margin-bottom:30px;">我们的服务</div>
            <div style="float: left;width: 100%;margin-bottom:4%">
              <div style="width: 100px;height: 10px;background: linear-gradient(127deg, #289EA5 0%, #14C89B 100%);margin: 0 auto;"></div>
            </div>


            <div style="width: 100%;overflow: hidden;padding-top: 60px;display: flex;">

              <div style="width: 350px;height: 460px;background: #FFFFFF;border-radius: 20px;padding:0px 45px;position: relative;flex: 1;margin-right: 75px;" class="donghua ctfw">
                <div>
                  <div style="width: 100%;">
                     <img src="@/assets/images/ctimaging/ctimg71.png" alt="" style="width: 166px;height:200px;position: absolute;top: -40px;left: 92px;">
                  </div>
                  
                   <div style="width: 260px;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #000000;">
                     
                   </div>
                   <div style="width: 270px;height: 165px;font-size: 14px;font-family: MicrosoftYaHei;color: #000000;line-height: 22px;position: absolute;top: 180px;left: 45px;">
                     通过对CT影像文本数据集进行分词处理并进行清洗，完成异常特征词语的精准划分和统计。按各部位下特征词频关联疾病贡献度不同生成特征权重。最后基于语义认知技术对特征上下文实现全局融合，筛选排除同义、否定、错误等特征，达到目标区域异常特征的精准识别。
                   </div>
                   <div class="ctfwbot" style="float: left;width: 100%;padding-top:40px;position: absolute;left: 0;overflow: hidden;">
                    <div style="width: 100px;height: 10px;background: linear-gradient(127deg, #289EA5 0%, #14C89B 100%);margin: 0 auto;"></div>
                  </div>
                </div>
              </div>

               <div style="width: 350px;height: 460px;background: #FFFFFF;border-radius: 20px;padding:0px 45px;position: relative;flex: 1;margin-right: 75px" class="donghua ctfw">
                <div>
                  <div style="width: 100%;">
                     <img src="@/assets/images/ctimaging/ctimg72.png" alt="" style="width: 166px;height:200px;position: absolute;top: -40px;left: 92px;">
                  </div>
                  
                   <div style="width: 260px;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #000000;">
                     
                   </div>
                   <div style="width: 270px;height: 165px;font-size: 14px;font-family: MicrosoftYaHei;color: #000000;line-height: 22px;position: absolute;top: 180px;left: 45px;">
                     通过对CT影像文本数据集进行分词处理并进行清洗，完成异常特征词语的精准划分和统计。按各部位下特征词频关联疾病贡献度不同生成特征权重。最后基于语义认知技术对特征上下文实现全局融合，筛选排除同义、否定、错误等特征，达到目标区域异常特征的精准识别。
                   </div>
                   <div class="ctfwbot"  style="float: left;width: 100%;padding-top:40px;position: absolute;left: 0;overflow: hidden;">
                    <div style="width: 100px;height: 10px;background: linear-gradient(127deg, #289EA5 0%, #14C89B 100%);margin: 0 auto;"></div>
                  </div>
                </div>
              </div>



               <div style="width: 350px;height: 460px;background: #FFFFFF;border-radius: 20px;padding:0px 45px;position: relative;flex: 1;" class="donghua ctfw">
                <div>
                  <div style="width: 100%;">
                     <img src="@/assets/images/ctimaging/ctimg73.png" alt="" style="width: 166px;height:200px;position: absolute;top: -40px;left: 92px;">
                  </div>
                   <div style="width: 260px;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #000000;">
                   </div>
                   <div style="width: 270px;height: 165px;font-size: 14px;font-family: MicrosoftYaHei;color: #000000;line-height: 22px;position: absolute;top: 180px;left: 45px;">
                     通过对CT影像文本数据集进行分词处理并进行清洗，完成异常特征词语的精准划分和统计。按各部位下特征词频关联疾病贡献度不同生成特征权重。最后基于语义认知技术对特征上下文实现全局融合，筛选排除同义、否定、错误等特征，达到目标区域异常特征的精准识别。
                   </div>
                   <div class="ctfwbot"  style="float: left;width: 100%;padding-top:40px;position: absolute;left: 0;overflow: hidden;">
                    <div style="width: 100px;height: 10px;background: linear-gradient(127deg, #289EA5 0%, #14C89B 100%);margin: 0 auto;"></div>
                  </div>
                </div>
              </div>
            </div>
            </div>
          </div>
        </el-carousel-item>

        <el-carousel-item key="8">

          <div style="float: left;width: 100%;position: relative;">
            <div   style="width: 100%;height: 100vh;position: absolute;z-index: 0;left: 0;top: 0;background: #fff;"></div>
            <div style="width: 1200px;height: 100vh;position: relative;margin: 0 auto;z-index: 1;">
              <div  style="width: 100%;float: left;margin-left: 0;margin-top: 10%;padding-bottom: 20px;">
                <div style="width: 100%;float: left;font-size: 40px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #000000;line-height: 52px;text-align: center;overflow: hidden;">解读内容模板</div>
                <div style="float: left;margin-top: 30px;width: 100%;">
                  <div style="width: 100px;height: 10px;background: linear-gradient(127deg, #289EA5 0%, #14C89B 100%);margin: 0 auto;"></div>
                </div>
                <div style="float: left;margin-top: 30px;width: 100%;padding-bottom: 30px;">
                    <div style="width: 1000px;height: 70px;font-size: 16px;font-family: MicrosoftYaHei;color: #000000;line-height: 24px;text-align: center;margin:0 auto;">影像科医生在工作时会观察各种医学影像（如CT、核磁共振影像），并对其作出文本描述，这些描述中包含了大量医学信息，根据不同目标区域的异常特征信息对医疗AI预测潜在疾病具有重要指导意义。其中如何根据医生对CT的影像描述文本数据，判断检测身体若干目标区域是否有异常以及异常的类型等应用实现是疾病预测的重要前提。
                  </div>
                </div>
              </div>


              <div style="width: 100%;" >
                <div class="donghua" style="width: 360px;height: 250px;background:#E8F8F6;border-radius: 10px;overflow: hidden;margin-right: 60px;float: left;">
                    <div style="width: 100px;height: 250px;background: linear-gradient(135deg, #289EA5 0%, #14C89B 100%);border-radius: 10px 0px 0px 10px;float:left;padding: 40px 0px;">
                      <div style="width: 100px;text-align: center;height: 156px;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #FFFFFF;line-height: 26px;writing-mode:vertical-rl;width: 60px;">  疾 病 风 险 指 数 </div>
                    </div>

                    <div style="float:left;padding-top: 76px;padding-left: 40px;line-height: 20px;">

                      ★ 健康指数<br/>
                      ★ 健康风险<br/>
                      ★ 异常提示<br/>
                      ★ 恶性风险<br/>
                    </div>
                </div>

                <div class="key8class donghua" style="margin-right: 60px;">
                    <div style="width: 100px;height: 250px;background: linear-gradient(135deg, #289EA5 0%, #14C89B 100%);border-radius: 10px 0px 0px 10px;float:left;padding: 40px 0px;">
                      <div style="text-align: center;height: 156px;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #FFFFFF;line-height: 26px;writing-mode:vertical-rl;width: 80px;">  解 读 <br/>潜 在 疾 病 风 险</div>
                      
                    </div>
                    <div style="float:left;padding-top:28px;padding-left: 40px;line-height: 20px;">
                      ★ 潜在疾病风险指数<br/>
                      ★ 风险因⼦分析<br/>
                      ★ 检查建议<br/>
                      ★ 风险趋势预测分析<br/>
                      ★ 风险解读<br/>
                      ★ 医学分析<br/>
                      ★ 饮食建议<br/>
                      ★ 运动建议
                    </div>
                </div>

                <div class="key8class donghua">
                    <div style="width: 100px;height: 250px;background: linear-gradient(135deg, #289EA5 0%, #14C89B 100%);border-radius: 10px 0px 0px 10px;float:left;padding: 40px 0px;">
                      <div style="text-align: center;height: 156px;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #FFFFFF;line-height: 26px;writing-mode:vertical-rl;width: 80px;"> 解 读 <br/>病 变 风 险 综 合</div>
                    </div>
                    <div style="float:left;padding-top:65px;padding-left: 40px;line-height: 20px;">
                      ★ 占位性病变风险<br/>
                      ★ 弥漫性病变风险<br/>
                      ★ 潜在疾病风险演变趋势分析<br/>
                      ★ 核⼼疾病风险评分排名<br/>
                      ★ 进一步检查建议
                    </div>
                </div>
              </div>
             
              

               <div style="width: 100%;">
                   <div   class="key8class donghua" style="margin-right: 60px;">
                    <div style="width: 100px;height: 250px;background: linear-gradient(135deg, #289EA5 0%, #14C89B 100%);border-radius: 10px 0px 0px 10px;float:left;padding: 40px 0px;">
                      <div style="text-align: center;height: 156px;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #FFFFFF;line-height: 26px;writing-mode:vertical-rl;width: 80px;"> 总 建 议 <br/>个 性 化 饮 食</div>
                    </div>
                    <div style="float:left;padding-top:52px;padding-left: 40px;line-height: 20px;">
                      ★ 忌吃、宜吃<br/>
                      ★ 每⽇摄⼊总能量推荐<br/>
                      ★ 饮食结构建议<br/>
                      ★ 饮食习惯详细建议<br/>
                      ★ 可食用食谱营养元素分布<br/>
                      ★ 一周食谱推荐
                    </div>
                </div>


                <div  class="key8class donghua" style="margin-right: 60px;">
                    <div style="width: 100px;height: 250px;background: linear-gradient(135deg, #289EA5 0%, #14C89B 100%);border-radius: 10px 0px 0px 10px;float:left;padding: 40px 0px;">
                      <div style="text-align: center;height: 156px;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #FFFFFF;line-height: 26px;writing-mode:vertical-rl;width: 80px;"> 总 建 议 <br/>个 性 化 运 动</div>
                      
                    </div>
                    <div style="float:left;padding-top:65px;padding-left: 40px;line-height: 20px;">
                        ★ 合理运动量<br/>
                        ★ 运动习惯建议<br/>
                        ★ 有氧运动、⼒量运动、柔韧<br/>
                        运动指导及风险提示<br/>
                        ★ 运动消耗建议<br/>
                    </div>
                </div>


                 <div class="key8class donghua">
                    <div style="width: 100px;height: 250px;background: linear-gradient(135deg, #289EA5 0%, #14C89B 100%);border-radius: 10px 0px 0px 10px;float:left;padding: 40px 0px;">
                      <div style="text-align: center;height: 156px;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #FFFFFF;line-height: 26px;writing-mode:vertical-rl;width:60px;"> 专 属 保 险 方 案</div>
                      
                    </div>
                    <div style="float:left;padding-top:53px;padding-left: 40px;line-height: 20px;">
                      ★ 保险匹配度<br/>
                      ★ 与您筛查结果匹配说明<br/>
                      ★ 保险推荐度<br/>
                      ★ 产品指数<br/>
                      ★ 保险详情<br/>
                      ★ 购买渠道<br/>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </el-carousel-item>


        <el-carousel-item key="9">

          
          <div style="float: left;width: 100%;position: relative;">
            <img src="@/assets/images/ctimaging/ctimg9.png"  style="width: 100%;height: 100vh;position: absolute;z-index: 0;left: 0;top: 0;opacity: 0.8;z-index: 0;">
            <div  style="width: 100%;height: 100vh;position: absolute;z-index: 1;left: 0;top: 0;">
                <div style="width: 100%;height: 100vh;margin: 0 auto;z-index: 1;position: relative;">

                  <div style="width: 100%;position: absolute;z-index: 1;top: 12vh;">
                      <div  style="width: 100%;float: left;font-size: 40px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #fff;text-align: center;overflow: hidden;margin-bottom:30px;">应用场景</div>

                    <div style="float: left;width: 100%;margin-bottom:120px;">
                          <div style="width: 100px;height: 10px;background:#fff;margin: 0 auto;"></div>
                    </div>
                    
                  </div>

                  <div style="display: flex;height: 100vh;position: relative;">


                  <div class="k9classli donghua1"  style="position:relative;">
                    <img src="@/assets/images/ctimaging/ctyiyuan1.png" style="width: 200px;height: 160px;margin-top: 34vh;margin-left: calc(50% - 100px)">


                    <div style="width: 100%;padding-top: 30px;">
                      <div style="width: 100%;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #FFFFFF;text-align: center;">医院</div>
                      <div class="k9classlibot">
                        助力医院影像科，提高出报告效率；影像解读服务，提升医院综合服务能力；信息化服务赋能医生诊断，矫正诊断结果，反向验证结论，提高报告准确度。

                      </div>
                    </div>
                  </div>


                   <div class="k9classli donghua1"  style="position:relative;">
                    <img src="@/assets/images/ctimaging/ctyiyuan2.png" style="width: 200px;height: 160px;margin-top: 34vh;margin-left: calc(50% - 100px)">
                    <div style="width: 100%;padding-top: 30px;">
                      <div style="width: 100%;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #FFFFFF;text-align: center;">医学院
                      </div>
                      <div class="k9classlibot">影像报告解读的有效教学工具，快速培养人才；创新诊疗模式，推进临床科研及成果转化。
                      </div>
                    </div>
                  </div>



                  <div class="k9classli donghua1"  style="position:relative;">
                    <img src="@/assets/images/ctimaging/ctyiyuan3.png" style="width: 200px;height: 160px;margin-top: 34vh;margin-left: calc(50% - 100px)">
                    <div style="width: 100%;padding-top: 30px;">
                      <div style="width: 100%;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #FFFFFF;text-align: center;">独立影像中心
                      </div>
                      <div class="k9classlibot" >系统赋能独立影像中心，与大医院进行差异化定位，通过前沿的智能的读片服务，切入更高端的市场；并通过智能解读为用户提供转诊服务，与合作医院进行服务互补。
                      </div>
                    </div>
                  </div>

                   <div class="k9classli donghua1"  style="position:relative;">
                    <img src="@/assets/images/ctimaging/ctyiyuan4.png" style="width: 200px;height: 160px;margin-top: 34vh;margin-left: calc(50% - 100px)">
                    <div style="width: 100%;padding-top: 30px;">
                      <div style="width: 100%;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #FFFFFF;text-align: center;">互联网医疗健康服务平台
                      </div>
                      <div  class="k9classlibot" style="">促进平台服务能力，通过线上智能阅片有效将客户进行分类，并根据分类进行个性化方案定制及服务拓展，增加用户粘性，提升平台持续盈利能力。
                      </div>
                    </div>
                  </div>
                </div>
            </div>
            </div>
            






            
          </div>
        </el-carousel-item>

         <el-carousel-item key="10">
          <img src="@/assets/images/ctimaging/ctk10back.png" alt="" style="width: 100%;height: 100vh;position: absolute;z-index: 0;left: 0;top: 0;">
          <div style="float: left;width: 100%;position: relative;">
            
            <div style="width: 1200px;height: 100vh;position: relative;margin: 0 auto;z-index: 1;">
            <div style="width: 100%;float: left;font-size: 40px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #000000;text-align: center;overflow: hidden;margin-top: 10%;margin-bottom:30px;">合作方式</div>

            <div style="float: left;width: 100%;margin-bottom:4%">
              <div style="width: 100px;height: 10px;background: linear-gradient(127deg, #289EA5 0%, #14C89B 100%);margin: 0 auto;"></div>
            </div>

            <div style="width: 100%;overflow: hidden;padding-top: 60px;display: flex;">
              <div style="margin-right: 75px;" class="k10classli">
                  <div style="width: 100%;padding-top: 42px">
                     <img src="@/assets/images/ctimaging/ctimg71.png" alt="" style="width:140px;height:140px;margin-left: calc(50% - 70px);padding-top: ;">
                  </div>
                  
                   <div style="width: 260px;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;">
                     
                   </div>

                   <div style="width: 100%;text-align:center;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;line-height: 26px;padding-top: 20px;">
                     取片机对接
                   </div>
                   <div style="padding-top: 20px; width: 270px;height: 165px;font-size: 14px;font-family: MicrosoftYaHei;line-height: 22px;top: 180px;left: 45px;">
                    用户取片时扫码支付并获取智能报告。
                   </div>
              </div>

               <div style="margin-right: 75px;" class="k10classli">
                  <div style="width: 100%;padding-top: 42px">
                     <img src="@/assets/images/ctimaging/ctimg71.png" alt="" style="width:140px;height:140px;margin-left: calc(50% - 70px);">
                  </div>
                  
                   <div style="width: 260px;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;">
                     
                   </div>

                   <div style="width: 100%;text-align:center;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;line-height: 26px;padding-top: 20px;">
                     API对接
                   </div>
                   <div style="padding-top: 20px; width: 270px;height: 165px;font-size: 14px;font-family: MicrosoftYaHei;line-height: 22px;top: 180px;left: 45px;">
                    可通过API形式对接到互联网健康及医疗平台，实现在线解读服务。
                   </div>
              </div>

              <div style="" class="k10classli">
                  <div style="width: 100%;padding-top: 42px">
                     <img src="@/assets/images/ctimaging/ctimg71.png" alt="" style="width:140px;height:140px;margin-left: calc(50% - 70px);">
                  </div>
                  
                   <div style="width: 260px;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;">
                     
                   </div>

                   <div style="width: 100%;text-align:center;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;line-height: 26px;padding-top: 20px;">
                     系统对接
                   </div>
                   <div style="padding-top: 20px; width: 270px;height: 165px;font-size: 14px;font-family: MicrosoftYaHei;line-height: 22px;top: 180px;left: 45px;">
                    支持对接院内系统，通过对接的信号识别、数据安全、信息结构化处理中间件服务对来源系统进行数据处理，通过人体医学生物特征认知计算平台对影像报告数据进行分析处理，为机构提供智能解读应用。
                   </div>
              </div>
                
            </div>
            </div>
          </div>

        
        </el-carousel-item>

        <el-carousel-item key="11">
          <div style="float: left;width: 100%;position: relative;">
            <div style="width: 100%;height: 100vh;position: absolute;z-index: 0;left: 0;top: 0;background: linear-gradient(129deg, #289EA5 0%, #14C89B 100%);"></div>
            <div style="width: 1200px;height: 100vh;position: relative;margin: 0 auto;z-index: 1;">

            <div style="width: 100%;float: left;font-size: 40px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #fff;text-align: center;overflow: hidden;margin-top: 10%;margin-bottom:30px;">了解更多</div>

            <div style="float: left;width: 100%;margin-bottom:60px;">
              <div style="width: 100px;height: 10px;background:#fff;margin: 0 auto;"></div>
            </div>


             
              <div style="width: 100%;float: left;margin-top: 10%;">
                <div style="width: 100%;float: left;font-size: 40px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #fff;line-height: 52px;text-align: center;"></div>
                
                <div style="width: 100%;float: left;">
                  <div style="width: 80%;padding: 0px 10%;display: flex;">
                    <div style="margin-right: 100px;flex: 1;height: 300px;background: rgba(255,255,255,0.4);border-radius: 10px;float: left;margin-left: 20px;">
                    <div style="width: 380px;height: 300px;background: #fff;border-radius: 10px;float: left;margin-left: -10px;margin-top: -10px;padding: 40px 30px;box-sizing: border-box;">
                      <div style="width: 100%;float: left;text-align: center;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #000000;">资料下载</div>
                     
                      <div style="float: left;width: 200px;height: 60px;background: linear-gradient(318deg, #289EA5 0%, #14C89B 100%);border-radius: 10px;font-size: 14px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #FFFFFF;line-height: 60px;text-align: center;margin-left:70px ;margin-top: 74px;"> <a class="aquchu" href="https://ftp.infobigdata.com/ctImageTextProductInformation.pdf" target="_blank">点击下载资料</a> </div>
                    </div>
                  </div>


                  <div style="flex: 1;height: 300px;background:rgba(255,255,255,0.4);border-radius: 10px;float: left;margin-left: 20px;">
                    <div style="width: 380px;height: 300px;background: #fff;border-radius: 10px;float: left;margin-left: -10px;margin-top: -10px;padding: 40px 30px;box-sizing: border-box;">
                      <div style="width: 100%;float: left;text-align: center;font-size: 20px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #000000;">获取报价</div>
                      <div style="float: left;width: 200px;height: 60px;background: linear-gradient(129deg, #289EA5 0%, #14C89B 100%);border-radius: 10px;font-size: 14px;font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;font-weight: bold;color: #FFFFFF;text-align: center;margin-left:70px ;margin-top: 74px;padding: 10px 0;box-sizing: border-box;cursor: pointer;" @click="cl = true">点击获取<br>详细方案及报价</div>
                    </div>
                  </div>
                  </div>
                  <div style="width: 100%;float: left;font-size: 14px;font-family: MicrosoftYaHei;color: #FFFFFF;line-height: 19px;text-align: center;margin-top: 160px;">© Copyright © 2017-2021 中润普达 - 京ICP备2021002262号-1</div>
                </div>
              </div>
              
            </div>
          </div>
        </el-carousel-item>

      </el-carousel>
    </div>
           <!-- <app-footer /> -->
    <div style="width: 100%;height: 100vh;position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;z-index: 999;
    background: rgba(0, 0, 0, 0.8);" v-if="cl" @click="cl = false">
      <img src="@/assets/images/cardiobrain/erweima.jpg" alt="" style="width: 10vw;height: 10vw;margin:0 45vw;margin-top:30vh;">
      <div style="width: 100%;text-align: center;font-size: 16px;color: #fff;margin-top: 10px;">扫码添加获取详细方案及报价</div>
    </div>
  </div>
</template>
<script>
import header from '@/components/header'
import footer from '@/components/footer'

export default {
  data() {
    return {
        cl: false,
      zoucl: true,
      scrollBox: { time: 300 },
      liclick: 1,

    }
  },
  mounted() {


  },
  methods: {
    zouni() {
      var myVideo = document.getElementById("video");
      if (myVideo.paused) {
        myVideo.play();
        this.zoucl = false;
      } else {
        myVideo.pause();
        this.zoucl = true;

      }

    },
    rollScroll(event) {
      console.log(event)
      let _that = this;
      let scrollVal = event.wheelDelta || event.detail;
      if (_that.scrollBox.time) {
        clearTimeout(_that.scrollBox.time)
      }
      _that.scrollBox.time = setTimeout(() => {
        scrollVal > 0 ? _that.$refs.carousel.prev() : _that.$refs.carousel.next();
      }, 300);
    },
  },
  components: {
    'app-header': header,
    'app-footer': footer,
  },
}

</script>
<style>
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}

.swiper-box .el-carousel__indicator--vertical .el-carousel__button {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background-color: #46CBB0;
  border: none;
  box-sizing: content-box;
  border: 2px solid rgba(0, 0, 0, 0);

}

.swiper-box .el-carousel__indicator.is-active button {
  background-color: #fff;
  border: 2px solid #46CBB0;
}
.yin1{
    width: 280px;
    height:500px;
    float: left;
    background: url(../assets/images/cardiobrain/yin1.png) 0 0 no-repeat ;
    padding: 40px 30px;
    box-sizing: border-box;
}
.yin2{
    width: 290px;
    height:240px;
    float: left;
    background: url(../assets/images/cardiobrain/yin2.png) 0 0 no-repeat ;
    margin-left: 20px; 
    padding: 40px 30px;
    box-sizing: border-box;
}
.yin3{
    width: 290px;
    height:240px;
    float: left;
    background: url(../assets/images/cardiobrain/yin3.png) 0 0 no-repeat ;
    margin-left: 20px; 
    padding: 40px 30px;
    box-sizing: border-box;
}
.yin4{
    width: 600px;
    height:240px;
    float: left;
    background: url(../assets/images/cardiobrain/yin4.png) 0 0 no-repeat ;
    margin-left: 20px;
    margin-top: 20px;
    padding: 40px 30px;
    box-sizing: border-box;
}
.yin5{
    width: 280px;
    height:500px;
    float: right;
    background: url(../assets/images/cardiobrain/yin5.png) 0 0 no-repeat ;
    margin-left: 20px;
    padding: 40px 30px;
    box-sizing: border-box;
}

.ctimaging .el-carousel__indicator.el-carousel__indicator--vertical .ziti{
  color: #FFF;
}
.ctimaging .el-carousel__indicator.el-carousel__indicator--vertical.is-active .ziti{
  color: #09BF88;

}
.ctimaging .key8class{
  width: 360px;height: 230px;background:#E8F8F6;border-radius: 10px;overflow: hidden;float: left;
  margin-bottom: 60px;
}
.ctimaging .k9classli{
  width: 25%;
  /*height: calc(100vh - 60px);*/
  height: 100vh;
  /*margin-top: 60px;*/
  background: rgba(0,0,0,0.8);
  opacity:1;
  flex: 1;
  position: relative;
}
.ctimaging .ctk6class{
  opacity: 0.8;
}
.ctimaging .ctk6classact{
  opacity: 1;
}
.ctimaging .ctk6class .ziti{
   color: rgb(9, 191, 136);
   background: #77D1C5;
  /*background: rgb(119, 209, 197);*/
}
.ctimaging .ctk6classact .ziti{
   background: rgb(255, 255, 255);
   color: rgb(9, 191, 136);
}
.ctimaging .k9classlibot{
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #FFFFFF;
    padding: 20px 10%;
    width: 80%;
    margin: auto;
}
 
.ctimaging .k9classli:hover{
  animation:animation1 1s;
  /*transition-duration: 1s;*/
  -webkit-animation:animation1 1s; /* Safari and Chrome */
  background: linear-gradient(180deg, #289EA5 0%, #14C89B 100%);
}


.ctimaging  .k10classli{
  box-shadow: 0px 4px 20px 0px rgba(29,180,159,0.3);
  border-radius: 20px;
  width: 350px;height: 460px;background: #FFFFFF;border-radius: 20px;padding:0px 45px;position: relative;flex: 1;
  color: #000;
}
.ctimaging  .k10classli:hover{
  animation:animation2 2s;
  -webkit-animation:animation2 2s; /* Safari and Chrome */
  color: #fff;
  background: linear-gradient(129deg, #289EA5 0%, #14C89B 100%);
  transition-timing-function:ease;
}
 
 .ctfw .ctfwbot{
  bottom: 0px;
  display: none;
 }
.ctimaging .donghua:hover .ctfwbot{
  bottom: 20px;
  display: block;
   animation:myfirst 2s;
  -webkit-animation:myfirst 2s; /* Safari and Chrome */
}
.ctimaging .donghua {
  -webkit-transition: -webkit-transform 1s ease;
  /* For Safari 3.1 to 6.0 */
  transition: transform 1s ease;
}

.ctimaging .donghua:hover {
  -ms-transform: scale(1.1);
  /* IE 9 */
  -webkit-transform: scale(1.1);
  /* Safari */
  transform: scale(1.1);
  /* 标准语法 */
}
.ctimaging .donghua1{
  animation:myfirst 2s;
  -webkit-animation:myfirst 2s; /* Safari and Chrome */
}
@keyframes animation1 {
  0%{opacity: 0,rgba(0,0,0,0.1);background: linear-gradient(180deg, #289EA5 0%, #14C89B 100%)}
  100%{opacity: 1;background: linear-gradient(180deg, #289EA5 0%, #14C89B 100%)}
}
@keyframes animation2 {
  0%{background: linear-gradient(129deg, #289EA5 0%, #14C89B 100%);opacity:0}
  100%{background: linear-gradient(129deg, #289EA5 0%, #14C89B 100%);color: #fff;opacity:1}
}
@keyframes myfirst
{
  from {opacity:0;}
  to {opacity:1;}
}

@-webkit-keyframes myfirst /* Safari and Chrome */
{
  from {opacity:0;}
  to {opacity:1;}
}
.aquchu {
  text-decoration: none;
  color: #fff;
}

.aquchu:hover,
.aquchu:visited,
.aquchu:link,
.aquchu:active {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/ctimaging.vue